import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackVisitor } from '../../utils/visitorTracking';

const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track visitor on route change
    trackVisitor(location.pathname);
  }, [location]);

  return null; // This component doesn't render anything
};

export default VisitorTracker;

